var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    className: "",
    cx: 256,
    cy: 267,
    r: 245,
    fill: "#475582",
    style: {},
    "data-original": "#1a2b63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M273.5 361.794v-53.615a27.039 27.039 0 0 1-6.443.779h-22.114c-2.221 0-4.378-.273-6.443-.779v53.615h35z",
    fill: "#ffaf10",
    style: {},
    "data-original": "#ffaf10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 361.794v-52.836h-9.057c-2.221 0-4.378-.273-6.443-.779v53.615H254z",
    fill: "#ef9614",
    style: {},
    "data-original": "#ef9614"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m256 285a107.18 107.18 0 0 1-38.086-6.961v4.93c0 14.927 12.101 27.028 27.029 27.028h22.114c14.928 0 27.029-12.101 27.029-27.028v-4.93a107.19 107.19 0 0 1-38.086 6.961z",
    fill: "#ffd00d",
    style: {},
    "data-original": "#ffd00d"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m248.89 284.76a106.95 106.95 0 0 1-30.979-6.721v4.93c0 14.927 12.101 27.028 27.029 27.028h22.114c1.499 0 2.968-0.127 4.4-0.362-12.259-2.008-21.738-12.259-22.564-24.875z",
    fill: "#ffaf10",
    style: {},
    "data-original": "#ffaf10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m295 382v-17c0-2.75-2.25-5-5-5h-68c-2.75 0-5 2.25-5 5v17h78z",
    fill: "#ef8318",
    style: {},
    "data-original": "#ef8318"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m247 382v-17c0-2.75 2.25-5 5-5h-30c-2.75 0-5 2.25-5 5v17h30z",
    fill: "#db722c",
    style: {},
    "data-original": "#db722c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.5 467v-82c0-2.75-2.25-5-5-5h-179c-2.75 0-5 2.25-5 5v82h189z",
    fill: "#a05f33",
    style: {},
    "data-original": "#a05f33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M177 467v-82c0-2.75 2.25-5 5-5h-15.5c-2.75 0-5 2.25-5 5v82H177z",
    fill: "#87502a",
    style: {},
    "data-original": "#87502a"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m323.02 445c0 2.75-2.25 5-5 5h-124.04c-2.75 0-5-2.25-5-5v-42c0-2.75 2.25-5 5-5h124.04c2.75 0 5 2.25 5 5v42z",
    fill: "#293d7c",
    style: {},
    "data-original": "#293d7c"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m208.96 445v-42c0-2.75 2.25-5 5-5h-19.977c-2.75 0-5 2.25-5 5v42c0 2.75 2.25 5 5 5h19.977c-2.75 0-5-2.25-5-5z",
    fill: "#475582",
    style: {},
    "data-original": "#1a2b63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.5 466h-231c-2.75 0-5 2.25-5 5v9.352C171.082 500.491 212.195 512 256 512s84.918-11.509 120.5-31.649V471c0-2.75-2.25-5-5-5z",
    fill: "#bf7e52",
    style: {},
    "data-original": "#bf7e52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166 471c0-2.75 2.25-5 5-5h-30.5c-2.75 0-5 2.25-5 5v9.352a244.1 244.1 0 0 0 30.5 14.571v-23.923z",
    fill: "#aa6b3f",
    style: {},
    "data-original": "#aa6b3f"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M424.255 25.591H385.5V34c0 2.206-1.794 4-4 4h-16.781a1 1 0 0 0-1 1v11.591h52.42c-2.141 43.803-21.944 83.041-52.42 110.732v15.962c0 5.808-.469 11.508-1.358 17.069 47.723-33.563 78.971-89.041 78.971-151.686 0-9.417-7.661-17.077-17.077-17.077z",
    fill: "#ffaf10",
    style: {},
    "data-original": "#ffaf10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M148.282 177.285v-15.962c-30.475-27.691-50.28-66.929-52.42-110.732h52.42V39a1 1 0 0 0-1-1H130.5c-2.206 0-4-1.794-4-4v-8.409H87.745c-9.416 0-17.077 7.661-17.077 17.077 0 62.646 31.249 118.124 78.971 151.687a108.083 108.083 0 0 1-1.357-17.07z",
    fill: "#ffd00d",
    style: {},
    "data-original": "#ffd00d"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m147.28 38v139.28c0 60.043 48.675 108.72 108.72 108.72s108.72-48.675 108.72-108.72v-139.28h-217.44z",
    fill: "#ef8318",
    style: {},
    "data-original": "#ef8318"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m169 177.28v-140.28h-21.718v140.28c0 60.043 48.675 108.72 108.72 108.72 3.641 0 7.234-0.193 10.782-0.545-54.908-5.485-97.782-51.822-97.782-108.17z",
    fill: "#db722c",
    style: {},
    "data-original": "#db722c"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "",
    cx: 256,
    cy: 155.5,
    r: 74,
    fill: "#db722c",
    style: {},
    "data-original": "#db722c"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M201 155.499c0-37.648 28.121-68.706 64.5-73.372a74.606 74.606 0 0 0-9.5-.628c-40.869 0-74 33.131-74 74s33.131 74 74 74c3.222 0 6.388-.229 9.5-.628-36.379-4.665-64.5-35.724-64.5-73.372z",
    fill: "#c95e23",
    style: {},
    "data-original": "#c95e23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M281.756 201.698c-1.223.001-2.474-.331-3.717-.985l-20.147-10.591c-.304-.16-.982-.347-1.891-.347-.91 0-1.588.187-1.894.347l-20.145 10.591c-1.244.654-2.495.985-3.717.985-1.856 0-3.517-.757-4.675-2.131-1.285-1.523-1.773-3.637-1.376-5.952l3.848-22.432c.169-.985-.454-2.902-1.169-3.6l-16.298-15.887c-2.122-2.069-2.891-4.633-2.11-7.035.781-2.402 2.91-4.023 5.842-4.449l22.522-3.272c.988-.144 2.62-1.329 3.062-2.225l10.072-20.41c1.312-2.657 3.512-4.18 6.038-4.18 2.526 0 4.727 1.523 6.037 4.18l10.073 20.41c.442.896 2.073 2.082 3.061 2.225l22.523 3.272c2.931.426 5.061 2.047 5.841 4.449.781 2.402.013 4.966-2.108 7.034l-16.299 15.888c-.716.697-1.339 2.615-1.17 3.6l3.847 22.432c.397 2.315-.091 4.429-1.375 5.952-1.159 1.374-2.82 2.131-4.675 2.131z",
    fill: "#ffd00d",
    style: {},
    "data-original": "#ffd00d"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m240.7 191.471 4.169-24.307c.183-1.067-.492-3.146-1.267-3.901l-17.661-17.215c-2.169-2.115-3.014-4.705-2.395-7.177l-9.241 1.343c-2.932.426-5.061 2.047-5.842 4.449-.781 2.402-.012 4.966 2.11 7.035l16.298 15.887c.715.697 1.338 2.615 1.169 3.6l-3.848 22.432c-.396 2.315.092 4.429 1.376 5.952 1.159 1.374 2.819 2.131 4.675 2.131 1.223 0 2.473-.331 3.717-.985l7.471-3.928c-.804-1.502-1.07-3.338-.731-5.316z",
    fill: "#ffaf10",
    style: {},
    "data-original": "#ffaf10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M386.5 34c0 2.75-2.25 5-5 5h-251c-2.75 0-5-2.25-5-5V5c0-2.75 2.25-5 5-5h251c2.75 0 5 2.25 5 5v29z",
    fill: "#ffd00d",
    style: {},
    "data-original": "#ffd00d"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M156 34V5c0-2.75 2.25-5 5-5h-30.5c-2.75 0-5 2.25-5 5v29c0 2.75 2.25 5 5 5H161c-2.75 0-5-2.25-5-5z",
    fill: "#ffaf10",
    style: {},
    "data-original": "#ffaf10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M127 331a3 3 0 0 1-2.842-2.04c-5.756-17.054-10.064-21.362-27.117-27.117a3 3 0 0 1-.001-5.685c17.053-5.755 21.361-10.064 27.117-27.117a3 3 0 0 1 5.684 0c5.756 17.053 10.064 21.362 27.117 27.117a3.001 3.001 0 0 1 0 5.685c-17.053 5.755-21.361 10.063-27.117 27.117A2.997 2.997 0 0 1 127 331z",
    fill: "#ffd00d",
    style: {},
    "data-original": "#ffd00d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.5 298a2.393 2.393 0 0 1-2.266-1.625c-4.586-13.59-8.02-17.023-21.609-21.609a2.393 2.393 0 0 1 0-4.531c13.59-4.586 17.023-8.02 21.609-21.609a2.391 2.391 0 0 1 4.532 0c4.586 13.589 8.02 17.022 21.609 21.609a2.393 2.393 0 0 1 0 4.531c-13.59 4.587-17.023 8.019-21.609 21.609A2.394 2.394 0 0 1 375.5 298zM283 419h-54a5 5 0 0 1 0-10h54a5 5 0 1 1 0 10zM271 437h-30a5 5 0 0 1 0-10h30a5 5 0 1 1 0 10zM195 80a2.251 2.251 0 0 1-2.132-1.53c-4.317-12.79-7.548-16.021-20.338-20.338a2.251 2.251 0 0 1 0-4.264c12.79-4.316 16.021-7.548 20.338-20.338a2.251 2.251 0 0 1 4.264 0c4.317 12.79 7.548 16.021 20.338 20.338a2.251 2.251 0 0 1 0 4.264c-12.79 4.317-16.021 7.548-20.338 20.338A2.251 2.251 0 0 1 195 80z",
    fill: "#fff",
    style: {},
    "data-original": "#ffffff"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.dc9ab3c5f6d5ebcd73359bfe7cab56ab.svg";
export { ForwardRef as ReactComponent };